import React, { useState, useEffect } from 'react';
import { api } from './App';
import { ArrowRight, Close } from './Icons';

const TOUR_STEPS = [
  {
    tab: 'dashboard',
    title: 'Your priority topics',
    text: 'These are your most urgent topics, ranked by confidence and exam proximity. Check this list before every study session.',
    hint: 'Looking at the dashboard now',
  },
  {
    tab: 'flk1',
    title: 'Rate your confidence',
    text: 'Move the slider on any topic to set your confidence. It saves instantly and recalculates your priorities.',
    hint: 'On FLK1 topics',
  },
  {
    tab: 'sra',
    title: '220 official SRA questions',
    text: 'Practice with questions mapped directly to your topics. Your results feed into the priority dashboard.',
    hint: 'On SRA Questions',
  },
  {
    tab: 'mcqresults',
    title: 'Import MCQ results',
    text: 'If you use BARBRI, paste your session results here. SQETrack maps scores to topics and sharpens your priorities.',
    hint: 'On MCQ Results',
  },
  {
    tab: 'timetable',
    title: 'Weekly revision planner',
    text: 'Plan your week here. Hit auto-fill to generate a schedule from your priority topics automatically.',
    hint: 'On the Planner',
  },
  {
    tab: 'recall',
    title: 'Active recall practice',
    text: 'Pick a topic, write down everything you remember in 3 minutes, then compare against the detail. Better than re-reading.',
    hint: 'On Recall',
  },
  {
    tab: 'progress',
    title: 'Track your progress',
    text: 'Your average confidence by module over time. Check this weekly to see what\'s improving and what needs more attention.',
    hint: 'On Progress',
  },
];

export default function TourOverlay({ setTab, onDone }) {
  const [step, setStep] = useState(0);
  const [exiting, setExiting] = useState(false);
  const current = TOUR_STEPS[step];
  const isLast = step === TOUR_STEPS.length - 1;

  useEffect(() => {
    setTab(current.tab);
  }, [step]); // eslint-disable-line

  const next = () => {
    if (isLast) finish();
    else setStep(s => s + 1);
  };

  const finish = async () => {
    setExiting(true);
    await api('/api/settings', { method: 'POST', body: JSON.stringify({ tour_shown: '1' }) });
    onDone();
  };

  return (
    <div className={`tour-backdrop ${exiting ? 'tour-exiting' : ''}`}>
      <div className="tour-panel">
        <div className="tour-panel-top">
          <span className="tour-step-pill">{step + 1} / {TOUR_STEPS.length}</span>
          <button className="tour-close-btn" onClick={finish} title="Skip tour">
            <Close size={12} />
          </button>
        </div>
        <div className="tour-hint">{current.hint}</div>
        <div className="tour-panel-title">{current.title}</div>
        <div className="tour-panel-text">{current.text}</div>
        <div className="tour-panel-footer">
          <div className="tour-dots">
            {TOUR_STEPS.map((_, i) => (
              <span key={i} className={`tour-dot ${i === step ? 'active' : i < step ? 'done' : ''}`} />
            ))}
          </div>
          <button className="tour-next-btn" onClick={next}>
            {isLast ? 'Finish tour' : <>Next <ArrowRight size={12} /></>}
          </button>
        </div>
      </div>
    </div>
  );
}
